// Remembers the last "list-like" route (list, timetable, archive, dashboard, ...)
// the user was on before drilling into a read/edit/new/copy detail screen.
//
// The reader's status actions (Approve/Flag/Submit/Archive) use this to return the
// user deterministically to where they came from — reactivating the kept-alive
// list/timetable with its filters intact — instead of a history-stack-dependent
// go(-1), which can land on an intermediate edit/new screen (e.g. edit-then-approve
// or create-then-approve).

let origin = null

// A "detail" route is a read/edit/new/copy screen (readEncounter, editPlot, newMonster,
// copyEncounter, ...). Every such route in this app is named with that CamelCase prefix.
// List/timetable/archive/filter/print routes are not, and are valid return targets.
const isDetailRoute = name => /^(read|edit|new|copy)[A-Z]/.test(name || '')

// Called from the global router guard on every navigation. Records `from` as the return
// target only when entering a detail route from a non-detail route, so that bouncing
// between sibling detail screens (e.g. read -> edit -> read) never overwrites the real origin.
export function recordNavigation(to, from) {
    if (from && from.name && isDetailRoute(to && to.name) && !isDetailRoute(from.name)) {
        origin = { name: from.name, params: { ...from.params }, query: { ...from.query } }
    }
}

// Navigate back to the recorded origin, falling back to the given route name when there
// is no recorded origin (e.g. the reader was reached via a deep link / page reload).
export function returnToOrigin(router, fallbackRouteName) {
    const target = origin || (fallbackRouteName ? { name: fallbackRouteName } : null)
    if (target) {
        router.push(target).catch(() => {})
    }
}
